/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMensesEvent } from 'app/shared/model/menses-event.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { PregnancySight } from 'app/shared/model/enumerations/pregnancy-sight.model';

export interface IPregnancyCase {
  id?: string;
  lmp?: number | null;
  expectedDueDate?: number | null;
  deliveryStatus?: boolean | null;
  pregnancyResult?: string | null;
  pregnancySight?: keyof typeof PregnancySight | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  event?: IMensesEvent | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IPregnancyCase> = {
  deliveryStatus: false,
  active: false,
  draft: false,
};
